export const TOOLTIP_FADE_OUT_TIMEOUT_MS = 3000;

export const TOOLTIP_FADE_TRANSITION_DURATION_MS = 500;
